import React, { createContext, type ReactNode, useContext, useMemo } from 'react'
import { type GroupSummary } from '@fs/zion-tree-types'
import { type GedcomFileFailed, type GedcomFile, type GedcomFileToGroupSummary } from '../../../services/groupTypes'

type AllTreeGroupsValue = {
  allGroups: (GroupSummary | GedcomFileToGroupSummary)[]
  failedFiles: GedcomFileFailed[]
  refetchFiles: () => void
  uploadedFiles: GedcomFile[]
  loadingUploadedFiles: boolean
}

const AllTreeGroups = createContext<AllTreeGroupsValue | undefined>(undefined)

export const useAllTreeGroups = (): AllTreeGroupsValue => {
  const context = useContext(AllTreeGroups)
  if (!context) throw new Error('You need to use the AllTreeGroupsProvider to use the useAllTreeGroups')
  return context
}

type Props = {
  children: ReactNode
  allGroupsData: AllTreeGroupsValue
}

export default function AllTreeGroupsProvider({ children, allGroupsData }: Props): JSX.Element {
  const value = useMemo(() => allGroupsData, [allGroupsData])
  return <AllTreeGroups.Provider value={value}>{children}</AllTreeGroups.Provider>
}
